<template>
  <div v-if="aibasketList">
        <Down v-if="isWeixins()" />
        <div :class="{'daily-list-panel':true,'iswx':isWeixins()}">
            <div v-if="$route.query.h" class="tab-test" :style="{'width': '100%','height': $route.query.h /100 + 'rem'}"></div>
            <div :class="{'daily-pro':true,'intelligence':false}">
                <!-- 可可爱爱没有脑袋 -->
                <Header :behavior="behavior" type="6" :info="info" :buy_info="buy_info" />
            </div>
            <!-- {/* ai智篮tab切换 */} -->
            <div :class="{'ai-tab':true, 'none':false}">
                <div @click="switchAiTab(1)">
                    <span :class="isActive==1? 'active':''">热门推荐<em></em></span>
                </div>
                <div @click="switchAiTab(2)">
                    <span :class="isActive==2? 'active':''">购买历史<em></em></span>
                </div>
            </div>
             <!-- {/* ai智篮分析列表 */} -->
            <div :class="{'ai-list': aibasketList && aibasketList.length > 0, 'none':false, 'closeai':closeAi}">
                <template v-if="closeAi">
                    <div class="daily-find">
                        <i class="daily-no-find"></i>
                        <p>当前nba赛事均已停赛，具体开赛时间以nba官方为准。去看其他模型～</p>
                    </div>
                </template>
                <template v-else-if="noai && aibasketList">
                    <template v-if="aibasketList && aibasketList.length > 0">
                        <div v-for="(item,index) in aibasketList" :key="index" class="ai-li clearfloat">
                            <div class="league fl-l">
                                <p>{{item.league_name_j}}</p>
                                <p>{{item.match_time.split(" ")[0].substr(5)}}</p>
                                <p>{{item.match_time.split(" ")[1].substr(0,5)}}</p>
                                </div>
                            <div class="team fl-l">
                                <template v-if="getCookies('bkb_away') == 1">
                                    <p><span>[客]</span><strong>{{item.away_name_j}}</strong></p>
                                    <p><span>[主]</span><strong>{{item.home_name_j}}</strong></p>
                                </template>
                                <template v-else>
                                    <p><span>[主]</span><strong>{{item.home_name_j}}</strong></p>
                                    <p><span>[客]</span><strong>{{item.away_name_j}}</strong></p>
                                </template>
                            </div>
                            <div class="score fl-l">
                                <template v-if="getCookies('bkb_away') == 1">
                                    <p><strong>{{item.away_score || ''}}</strong></p>
                                    <p><strong>{{item.home_score || ''}}</strong></p>
                                </template>
                                <template v-else>
                                    <p><strong>{{item.home_score || ''}}</strong></p>
                                    <p><strong>{{item.away_score || ''}}</strong></p>
                                </template>
                            </div>
                            <div :class="{'btn':true,'fl-r':true,'disabled':btncss(item.status,item.match_state)=='-1','needbuy':btncss(item.status,item.match_state) == '0'}">
                                <div onClick={self.goBuyAibasket.bind(self,item)}>
                                    <template v-if="item.status == 1">
                                        详情
                                    </template>
                                    <template v-else-if="item.status == 2">
                                        免费试看
                                    </template>
                                    <template v-else>
                                        {{info.price + (hiscores ? "金币" : "嗨币")}}
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <template v-if="isActive == 1">
                            <div class="daily-find">
                                <i class="daily-no-find"></i>
                                <p>暂无数据</p>
                            </div>
                        </template>
                        <template v-else>
                            <div class="daily-find">
                                <i class="daily-no-buy"></i>
                                <p>暂无购买记录</p>
                            </div>
                        </template>
                    </template>
                </template>
            </div>
        </div>
  </div>
</template>

<script>
import Down from "../../components/programme/appdown.vue"
import Header from "../../components/modelTemporary/header.vue"
import mutil from "../../utils/mutil.js"
import { getDataTypeListApi } from "../../api/modelTemporary"
import { urlQuery, setTitle, isWeiXin, getCookie, isHiscores } from "../../utils/base"
import { shareinit } from "../../utils/share"
export default {
    name: "AiZhilan",
    components: {
        Down,
        Header
    },
    data () {
        return {
            closeAi: false,
            loading: false,
            noai: false,
            aibasketList: null,
            buy_info: {},
            info: {},
            isActive: 1,
            behavior: this.$route.query.behavior || "",
            hiscores: 0,
            // 数据模型title
            dataTitleList: {
                1: '大热',
                2: '悬殊',
                3: '同赔',
                4: '极限',
                5: '庄家态度',
                6: 'Ai智篮分析',
                15: '大数据报告',
                16: '全维预测',
                17: '指数波动',
                18: '冷门分析',
                19: '情报速递',
                20: '数据雷达',
                21: '泊松分布',
                22: '超级必发'
            }
        }
    },
    created () {
        this.getDataTypeList()
        // 嗨比分
        if (isHiscores()) {
            this.hiscores = 1
        }
    },
    methods: {
        //  AI篮球tab切换
        switchAiTab (num) {
            if (!this.noai) {
                return;
            }
            var tabParams = "h";
            if (num === 1) {
                tabParams = "r";
            } else {
                tabParams = "h";
            }
            this.aibasketList = []
            this.isActive = num
            this.noai = false
            this.getDataTypeList(null, null, null, tabParams);
        },
        btncss (one, two) {
            // 按钮样式
            // eslint-disable-next-line eqeqeq
            if (one == 1) {
                return "1";
            // eslint-disable-next-line eqeqeq
            } else if (one == 2) {
                return "1";
            } else {
                // eslint-disable-next-line eqeqeq
                if (two > 0 || two == -1) {
                    return "-1";
                } else {
                    return "0";
                }
            }
        },
        getCookies (key) {
            return getCookie(key)
        },
        isWeixins () {
            return isWeiXin()
        },
        // 数据列表页
        async getDataTypeList (year, month, day, tab, cold) {
            this.loading = true
            const jsons = {};
            const type = 6;
            let time = urlQuery("time") || "";
            // 320之前版本ios做区分
            const src = urlQuery("src") || "";
            var iosArr = [];
            var iosVersion = 0;
            if (src.indexOf("ios_AppStore") > -1 && src.indexOf("hiscores") < 0) {
                iosArr = src.split("_");
            } else {
                iosArr = [];
            }
            if (iosArr && iosArr.length > 0) {
                iosVersion = iosArr[2];
            } else {
                iosVersion = 0;
            }
            jsons.type = type;
            // eslint-disable-next-line eqeqeq
            jsons.tab = tab || "r";
            if (year && month && day) {
                if (day < 10) {
                    day = "0" + day;
                }
                if (month < 10) {
                    month = "0" + month;
                }
                time = year + "-" + month + "-" + day;
            }
            if (time) {
                jsons.time = time;
            }
            setTitle(mutil.dailyMap[type + '']);
            // eslint-disable-next-line eqeqeq
            if (jsons.tab === "r" && iosVersion && iosVersion * 1 < 320) {
                this.closeAi = true;
            } else {
                this.closeAi = false;
            }
            const data = await getDataTypeListApi(jsons)
            // eslint-disable-next-line eqeqeq
            if (data && data.errno == '0') {
                var daily = data.data;
                this.aibasketList = daily
                this.buy_info = {
                    total: data.buy_info.total,
                    avatar: data.buy_info.avatar
                }
                this.info = {
                    name: data.info.name,
                    description: data.info.description,
                    status: data.info.status || "6",
                    endTime: data.info.endTime || "",
                    tags: data.info.tags,
                    price: data.info.price || ""
                }
                this.loading = false
                this.noai = true
                const linkUrl = document.URL + "&invite_id=" + data.invite_id;
                var shareobj = {
                    title: '即嗨正当红大数据模型！——' + (this.dataTitleList[type]) + '，当前已有' + (this.buy_info && this.buy_info.total) + '人订阅',
                    desc: "最高预测命中率达91%！来“即嗨”，看赛事数据！",
                    link: linkUrl,
                    imgUrl: "https://s.jihaimall.com/h5/image/jhtylogo.png"
                }
                shareinit(shareobj);
            }
        }
    }
}
</script>

<style>
@import url("../../assets/css/_discovery.min.css");
</style>
